import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const headers: any = new HttpHeaders({
  'Content-Type': 'application/json'
});
@Injectable({
  providedIn: 'root',
})

export class ConnectOrchestratorService {


  constructor(private http: HttpClient) { }

  getCitiesCredit365() {
    return this.http.get('assets/data/conects/city_creditos365.json');
  }
  getCitiesDaneId() {
    return this.http.get('assets/data/ciudades.json');
  }

  //Servicio para registrar el abandono de la oferta en el flujo de conectas
  registerOfferAbandonment(body: any) {
    return this.http.post(environment.APIEndpoint_bank + environment.Bank.registerOfferAbandonment, body, { headers });
  }

}